// Componente per la gestione dello Style
import {get} from './Storage';
import * as Colors  from 'material-ui/styles/colors';

var AppSettings = get();
var primaryColor = AppSettings.theme.primarycolor;

//Altezza del ViewPort
var viewPortHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);

var Styles =  {

    iconFilter:{
       color:Colors.grey500, 
       fontSize:"18px" 
    },
    pointer:{
        cursor:"pointer"
    },
    tooltipStyle:{
        right:'40px',
        zIndex:"9000"
    },
    topIconStyle: {
        fontSize: '24px',
        color: Colors.grey500,
        minWidth: 'initial'
    },
    badgeNotifications: {
        padding: "0px"
        //fontWeight: '900'
    },
    badgeTabNotifications:{
        padding: "0px",
        fontWeight: '900',
        top:'-10px',
        right:'-10px',
        position:'absolute',
    },
    badgeStyle:{
        backgroundColor: Colors.red500,
        fontWeight: '700',
        color:Colors.white,
        zIndex:'999'
    },
    boldStyle700: {
        fontWeight: '700'
    },
    noBorder:{
        border:'0'
    },

    topFilterIconStyle: {
        fontSize: '18px',
        color: Colors.grey500,
        minWidth: 'initial'
    },

    filerBadgeStyle:{
        backgroundColor: Colors.green300,
        fontWeight: '700',
        color:Colors.white,
        zIndex:'999',
        fontSize:'9px',
        width:'20px',
        height:'20px'
    },

    mgCardTitle: {
        fontWeight: '700',
        textTransform: 'uppercase',
        fontSize: '11px'
    },
    mgCardSubTitle: {
        fontSize: '11px',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        maxWidth: '200px'
    },
    cardText: {
        fontSize: '11px',
        minHeight:'100px',
        textAlign:'left',
    },
    cardMiniIcon:{
        fontSize: '15px',
        padding:'0',
        width: 'auto', 
        height: 'auto',
        position:'absolute',
        right:'0',
        bottom:'11px'   
    },
    miniIcon:{
        fontSize: '15px',
    },

    ecouponPokerTitle: {
        background: Colors.red200,
        color: Colors.red900,
        fontWeight: '700',
        textTransform: 'uppercase',
        fontSize: '11px'
    },
    ecouponPokerTxt: {
        background: Colors.red100,
        color: Colors.red900,
        fontWeight: '700',
        fontSize: '11px'
    },
    ecouponPokerSubTitle: {
        color: Colors.red900,
        textTransform: 'none',
        fontSize: '11px'
    },
    ecouponCasinoTitle: {
        background: Colors.yellow200,
        color: Colors.yellow900,
        fontWeight: '700',
        textTransform: 'uppercase',
        fontSize: '11px'
    },
    ecouponCasinoTxt: {
        color: Colors.yellow900,
        background: Colors.yellow100,
        fontSize: '11px',
        fontWeight: '700'
    },
    ecouponCasinoSubTitle: {
        color: Colors.yellow900,
        textTransform: 'none',
        fontSize: '11px'
    },
    iconButtonStyle: {
        fontSize: '10px'
    },
    iconButtonRefresh: {
        color: Colors.grey600
    },
    labelCTA: {
        fontSize: '13px',
        fontWeight: '700',
        color: Colors.grey500
    },
    fullWidth: {
        width: '100%',
        display: 'block'
    },
    btnRicarica: {
        width: '100%',
   },
    labelWhite:{
        color:'#fff',
        fontSize: '13px',
        fontWeight: '700'
    },
    margin5: {
        margin: '0 5px'
    },
    marginAuto:{
        margin:'0 auto'
    },
    tdTable: {
        padding: '2px 0',
        fontSize: '11px',
        textAlign: 'left',
        width:'100%',
        height:'auto',
        verticalAlign:'middle',
        display:'block'
    },
    trTable:{
        height:'40px'
    },
    mgTabsWrap: {
        background: Colors.grey200,
    },
    mgTabLabel: {
        background: Colors.white,
        boxShadow:'rgba(0, 0, 0, 0.117647) 0px 1px 6px, rgba(0, 0, 0, 0.117647) 0px 1px 4px'
    },
    tabs: {
        overflowY: 'auto',
        overflowX: 'hidden',
        paddingBottom: '50px'
    },

    newsContainer: {
        height: viewPortHeight - 80,

    },
    noRead:{
        background: Colors.grey300,
        borderLeft: '5px solid '+primaryColor,
        textAlign:'left'
    },
    Read:{
        background: Colors.grey100,
        textAlign:'left'
    },
    avatarRead:{
        background: Colors.green100
    },
    noAvatarRead:{
        background: primaryColor

    },
    iconBalance:{
        padding:'0px',
        height:'auto',
        borderRadius: '50%'
    },
    showBalance: {
        color: Colors.lightGreen900
    },
    showBalanceToolbar:{
        color:primaryColor
    },
    loadingIcon: {
        margin: '50px auto',
        textAlign: 'center',
        display:'block'
    },
    iconClockLogin:{
        fontSize:'12px',
        marginRight: '2px',
        color: primaryColor
    },
    bgPokerColor:{
        background: Colors.red900
    },
    mgCardStyle:{
        background: Colors.white
    },
     memoInput:{
        background: Colors.white,
        padding:'5px'
    }, 
    primaryColor:{
        color:primaryColor
    },
    primaryBorderColor:{
        borderColor:primaryColor
    },
    primaryBackgroundColor:{ 
        backgroundColor:primaryColor
     },
     primaryContrastBackgroundColor:{ 
        backgroundColor:primaryColor,
        color: Colors.white
     },
     zindex9999:{
            zIndex:'9999',
     },
      fontSize11:{
            fontSize:'11px'
     }
  
};

/*
if(AppSettings.theme.version == 'dark'){
    Styles['mgCardStyle']['background'] = Colors.grey800;
    Styles['Read']['background'] = Colors.grey900;
    Styles['noRead']['background'] = Colors.grey800;
 }
else{
}*/

export default Styles;
//export default Styles;